import { Icon } from '@iconify/react';

const About = () => {
  // Data statistik
  const stats = [
    { value: '0', label: 'Perusahaan' },
    { value: '0+', label: 'Pengguna' },
    { value: '0%', label: 'Kepuasan' },
  ];

  // Core Values
  const coreValues = [
    { icon: 'mdi:heart-outline', title: 'Berorientasi pada Manusia', color: 'bg-rose-50', iconColor: 'text-rose-600' },
    { icon: 'mdi:lightbulb-outline', title: 'Inovasi Berkelanjutan', color: 'bg-blue-50', iconColor: 'text-blue-600' },
    { icon: 'mdi:shield-check-outline', title: 'Integritas & Kepercayaan', color: 'bg-emerald-50', iconColor: 'text-emerald-600' },
    { icon: 'mdi:account-group-outline', title: 'Kolaborasi Tim', color: 'bg-amber-50', iconColor: 'text-amber-600' },
    { icon: 'mdi:target', title: 'Fokus pada Hasil', color: 'bg-zentra-50', iconColor: 'text-zentra-600' },
  ];

  return (
    <section id="tentang" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">

        {/* ===== HEADER ===== */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-zentra-50 rounded-full px-4 py-1.5 mb-4">
            <Icon icon="mdi:information" className="text-zentra-500 text-sm" />
            <span className="text-xs font-medium text-zentra-600">Tentang Kami</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight">
            Membangun Masa Depan Manajemen SDM yang{' '}
            <br className="hidden sm:block" />
            <span className="text-zentra-600">Lebih Cerdas</span> dan{' '}
            <span className="text-zentra-600">Humanis</span>
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto leading-relaxed">
            Zentra lahir dari keyakinan bahwa manajemen SDM harusnya tidak rumit.
            Kami menggabungkan teknologi AI terdepan dengan pendekatan yang humanis,
            menciptakan platform yang benar-benar memahami kebutuhan perusahaan Indonesia.
          </p>
        </div>

        {/* ===== STATS ===== */}
        <div className="grid grid-cols-3 gap-6 max-w-2xl mx-auto mb-20">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <p className="text-3xl md:text-4xl font-bold text-zentra-600">{stat.value}</p>
              <p className="text-sm text-gray-500 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* ===== CORE VALUES ===== */}
        <div>
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-12">
            Nilai-Nilai Inti Kami
          </h3>
          <div className="grid md:grid-cols-5 gap-4">
            {coreValues.map((value, index) => (
              <div
                key={index}
                className="text-center p-5 bg-white rounded-xl border border-gray-100 hover:border-zentra-200 hover:shadow-md transition-all"
              >
                <div className={`w-12 h-12 mx-auto rounded-xl ${value.color} flex items-center justify-center mb-3`}>
                  <Icon icon={value.icon} className={`text-xl ${value.iconColor}`} />
                </div>
                <h4 className="text-sm font-semibold text-gray-900">{value.title}</h4>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default About;
